export const INTEGRATION_SERVICE_ENDPOINT = window.env.VUE_APP_INTEGRATION_SERVICE_URL;

/***** Resource paths *****/
export const INTEGRATION_VARIABLES_RESOURCE_PATH = '/variables';


